import * as React from "react";
const SvgMinus = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 2"
    width="0.8em"
    height="0.8em"
    {...props}
  >
    <path
      d="M16 1a1 1 0 0 0-1-1H1a1 1 0 1 0 0 2h14a1 1 0 0 0 1-1"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMinus;
